import { combineReducers } from "redux";
import auth from "./auth";
import loyalty from "./loyalty";
import menu from "./menu";
import user from "./user";
import restaurants from "./restaurants";

export default combineReducers({ auth, loyalty, menu, user, restaurants });
